//import { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { ForbiddenError } from "../components/ErrorBoundary";
import {
  StructParams,
  StructureBase,
  getChildType,
  QueryStructParams,
  VDCounts,
} from "../lib/structures";
//import type { Timeline, TimelineTags } from "../types/Timeline";
import { useEffect } from "react";

export interface crunchWeekCanvassingLeaderBoardDataForChildren /*extends tabsData*/ {
  province_detail: Array<{
    prov_name: string;
    prov_code: string;
    perc: number;
    country_rank: number;
    // extract_date: string;
  }>;
  constituency_detail: Array<{
    prov_name: string;
    prov_code: string;
    const_code: string;
    const_name: string;
    perc: number;
    country_rank: number;
    province_rank: number;
  }>;
  region_detail: Array<{
    prov_name: string;
    prov_code: string;
    region_code: string;
    region_name: string;
    perc: number;
    country_rank: number;
    province_rank: number;
  }>;
  big_ward_detail: Array<{
    prov_name: string;
    prov_code: string;
    const_code: string;
    const_name: string;
    ward_code: string;
    ward_name: string;
    perc: number;
    country_rank: number;
    province_rank: number;
    constituency_rank: number;
  }>;
  medium_ward_detail: Array<{
    prov_name: string;
    prov_code: string;
    const_code: string;
    const_name: string;
    ward_code: string;
    ward_name: string;
    perc: number;
    country_rank: number;
    province_rank: number;
    constituency_rank: number;
  }>;
  small_ward_detail: Array<{
    prov_name: string;
    prov_code: string;
    const_code: string;
    const_name: string;
    ward_code: string;
    ward_name: string;
    perc: number;
    country_rank: number;
    province_rank: number;
    constituency_rank: number;
  }>;
  //refresh: Refresh;
}

export interface StructureWithcrunchWeekCanvassingLeaderBoard extends StructureWithcrunchWeekCanvassingLeaderBoardBase {
  crunchWeekCanvassingLeaderboard: crunchWeekCanvassingLeaderBoardDataForChildren;
  parents: StructureBase[];
  children: StructureWithcrunchWeekCanvassingLeaderBoardBase[];
}

interface StructureReturns {
  stats: StructureWithcrunchWeekCanvassingLeaderBoard | undefined;
  loading: boolean;
  refetch?: any;
  setRefreshStatus?: any;
  //refreshLoading?: boolean;
}

interface StructureWithcrunchWeekCanvassingLeaderBoardBase extends StructureBase {
  crunchWeekCanvassing: crunchWeekCanvassingLeaderBoardDataForChildren;
  counts: VDCounts;
}

interface crunchWeekCanvassingLeaderBoardResult {
  structure: StructureWithcrunchWeekCanvassingLeaderBoard;
}

const query = gql`
  query getcrunchWeekCanvassingLeaderBoardData(
    $type: String!
    $code: String!
    $childType: String!
    $filterLabel: String
  ) {
    structure(type: $type, code: $code, filterLabel: $filterLabel) {
      type
      code
      name
      responsiblePersons {
        firstname
        surname
        displayname
      }
      userHasAccess
      structureHasAssignedWards
      counts {
        total
        filtered
      }
      crunchWeekCanvassingLeaderboard {
        province_detail {
          prov_name
          prov_code
          perc
          country_rank
        }
        constituency_detail {
          prov_name
          prov_code
          const_code
          const_name
          perc
          country_rank
          province_rank
        }
        region_detail {
          prov_name
          prov_code
          region_code
          region_name
          perc
          country_rank
          province_rank
        }
        big_ward_detail {
          prov_name
          prov_code
          const_code
          const_name
          ward_code
          ward_name
          perc
          country_rank
          province_rank
          constituency_rank
        }
        medium_ward_detail {
          prov_name
          prov_code
          const_code
          const_name
          ward_code
          ward_name
          perc
          country_rank
          province_rank
          constituency_rank
        }
        small_ward_detail {
          prov_name
          prov_code
          const_code
          const_name
          ward_code
          ward_name
          perc
          country_rank
          province_rank
          constituency_rank
        }
      }
      parents {
        type
        code
        name
        userHasAccess
      }
      children(type: $childType) {
        type
        code
        name
        responsiblePersons {
          firstname
          surname
          displayname
        }
        userHasAccess
        structureHasAssignedWards
        counts {
          total
          filtered
        }
        crunchWeekCanvassingLeaderboard {
          province_detail {
            prov_name
            prov_code
            perc
            country_rank
          }
          constituency_detail {
            prov_name
            prov_code
            const_code
            const_name
            perc
            country_rank
            province_rank
          }
          region_detail {
            prov_name
            prov_code
            region_code
            region_name
            perc
            country_rank
            province_rank
          }
          big_ward_detail {
            prov_name
            prov_code
            const_code
            const_name
            ward_code
            ward_name
            perc
            country_rank
            province_rank
            constituency_rank
          }
          medium_ward_detail {
            prov_name
            prov_code
            const_code
            const_name
            ward_code
            ward_name
            perc
            country_rank
            province_rank
            constituency_rank
          }
          small_ward_detail {
            prov_name
            prov_code
            const_code
            const_name
            ward_code
            ward_name
            perc
            country_rank
            province_rank
            constituency_rank
          }
        }
      }
    }
  }
`;

export function useCrunchCanvassingLeader({
  type,
  code,
  filterLabel,
}: StructParams): StructureReturns {
  //const [refreshStatus, setRefreshStatus] = useState<boolean>(true);
  //const [refreshLoading, setRefreshLoading] = useState<boolean>(false);
  const childType = getChildType({ type, code });
  const { error, data, refetch, loading } = useQuery<
    crunchWeekCanvassingLeaderBoardResult,
    QueryStructParams
  >(query, {
    variables: { type, code, childType, filterLabel },
    notifyOnNetworkStatusChange: true,
  });

  // const fetchData = async () => {
  //   try {
  //     setRefreshLoading(true);
  //     await refetch();
  //   } catch (error: any) {
  //     console.error(error);
  //   } finally {
  //     setRefreshLoading(false);
  //   }
  // };

  useEffect(() => {
    refetch();
    //console.log("graphql: [crunch data]", data);
  }, [filterLabel, refetch]);

  if (error?.graphQLErrors[0]?.extensions?.code === "FORBIDDEN") {
    throw new ForbiddenError("this structure");
  }
  if (error != null) throw error;

  return {
    stats: data?.structure,
    loading: loading,
    //refetch: refetch,
    //setRefreshStatus: setRefreshStatus,
    //refreshLoading: refreshLoading,
  };
}
